var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8081 0.835938C24.3707 0.835938 31.292 8.0332 31.292 16.9372C31.292 25.8412 24.3707 33.0385 15.8081 33.0385C7.24551 33.0385 0.324219 25.8412 0.324219 16.9372C0.324219 8.0332 7.24551 0.835938 15.8081 0.835938ZM21.3668 8.88657L15.8081 14.6669L10.2494 8.88657L8.06615 11.1568L13.6249 16.9372L8.06615 22.7176L10.2494 24.9878L15.8081 19.2075L21.3668 24.9878L23.55 22.7176L17.9913 16.9372L23.55 11.1568L21.3668 8.88657Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.667f69926df873999f5b87c2cae0c9cb.svg";
export { ForwardRef as ReactComponent };